import { useState, useEffect } from "react";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
function useAgentProfiles({
  viewType,
  fields,
  displayName,
  defaultFilters,
  validateFilter,
  cleanDelay,
  agentProfileEntity
}) {
  const { items, handleFilterChange } = useViewInit({
    viewType,
    entity: {
      entity: agentProfileEntity,
      fields
    },
    displayName,
    defaultFilters,
    validateFilter,
    cleanDelay
  });
  return { items, handleFilterChange };
}
function useAgentAutocompleteOptions({
  agentProfiles,
  isTreeMode,
  displayUid
}) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    setOptions(getOptions());
  }, [agentProfiles?.map((a) => a.uid)?.join()]);
  function getOptions() {
    return isTreeMode ? getAgentTreeOptions(agentProfiles) : agentProfiles?.map((i) => ({ label: i.username, value: i.uid, subLabel: displayUid ? i.uid : void 0 }));
  }
  function getAgentTreeOptions(agents) {
    const result = [];
    const itemsDict = {};
    const agentsUids = new Set(agents?.map((a) => a.uid));
    agents?.forEach((agent) => {
      let currentNode = itemsDict[agent.uid];
      if (currentNode) {
        currentNode.value = agent.uid;
        currentNode.label = agent.username;
      } else {
        currentNode = { value: agent.uid, label: agent.username };
        itemsDict[agent.uid] = currentNode;
      }
      const parentId = agent.referral?.inviting_user_id;
      const parentNode = itemsDict[parentId];
      if (parentId && parentNode) {
        parentNode.subOptions = [...parentNode?.subOptions ?? [], currentNode];
      } else {
        if (parentId && agentsUids.has(parentId)) {
          itemsDict[parentId] = { subOptions: [currentNode] };
        } else {
          result.push(currentNode);
        }
      }
    });
    return result;
  }
  return {
    options
  };
}
export {
  useAgentAutocompleteOptions,
  useAgentProfiles
};
//# sourceMappingURL=hooks.js.map
